<template>
  <div>
    <slot />
  </div>
</template>

<script>
import { startNotifications, sendMixpanelNotification } from '@/@core/utils/notifications/notifications';

export default {
  name: 'MainContainer',
  async created() {
    const userKey = this.$store.getters.loggedUser?.key;
    const communitySlug = 'mynectios';  //antes: nectios
    await startNotifications({ userKey, communitySlug });
    await sendMixpanelNotification('user-in-mynectios');
  },

};
</script>
